import getCurrentStep from './getCurrentStep';

export default getCurrentStep;
